import { Factory } from '../Factory';
import { Service } from '../Service';

namespace app.services.project {

  export class ProjectService extends Service<any> {
    private currentProject: any;
    private httpService: app.services.IHttpWrapperService;
    private configService: app.services.IConfigService;

    constructor(resource: any, rootScope: IRootScope, configService: app.services.IConfigService, resourceWrapperService: ResourceWrapperService, httpService: app.services.IHttpWrapperService) {
      super({resource, rootScope, resourceWrapperService});

      this.httpService = httpService;
      this.configService = configService;

      let projectResource = this.resource(`${configService.getServerBaseUrlForResource()}/project/:id`,
        {id: "@id"}, {update: {method: "PUT"}}
      );

      this.itemResource = this.resourceWrapperService.WrapActions(projectResource);

      rootScope.$on('clearCurrentSelected', () => this.ClearCurrentProject());

      rootScope.$on(EVENTS.LOGIN_REQUIRED, () => this.ClearCurrentProject());
    }

    public Hibernate(project: IProject, token: any, successCallback?: Function, errorCallback?: Function) {
      this.httpService.$http({
        method: 'PUT',
        url: `${this.configService.getServerBaseUrl()}/project/${project.id}/hibernate`,
        data: {token: token}
      }).success(response => successCallback?.call(this, response)).error(() => errorCallback?.call(this));
    }

    public SetCurrentProject(project: IProject) {
      this.currentProject = project;
      if (project.status === Status.Active) {
        this.configService.setFullViewMode("direct");
      } else {
        this.configService.setFullViewMode("local");
      }

      this.rootScope.$broadcast("ProjectService.CurrentProjectChanged", this.currentProject);
    }

    public ClearCurrentProject() {
      this.currentProject = null;
      this.rootScope.$broadcast("ProjectService.CurrentProjectChanged", this.currentProject);
    }

    public GetCurrentProject() {
      return this.currentProject;
    }

    public FindOneOrCurrentProject(query: any, cachingEnabled: boolean = true) {
      // Check if we have this project cached and caching is enabled; if so, return it immediately
      // while still refreshing in the background.
      if (cachingEnabled && this.currentProject && this.currentProject.id === query.id) {
        // Return cached project immediately, but still fetch fresh data
        this.FindOne(query, true);
        return Promise.resolve(this.currentProject);
      }

      // No cache or caching disabled, fetch normally (respecting cachingEnabled for the service-level cache)
      return this.FindOne(query, cachingEnabled);
    }

    public RefreshProjects(callback?: Function) {
      this.ClearCurrentProject();
      callback?.call(this);
    }

    public Delete(project: IProject, token: string, successCallback?: Function, errorCallback?: Function) {
      this.httpService.$http({
        method: 'DELETE',
        url: `${this.configService.getServerBaseUrl()}/project/${project.id}`,
        data: {token: token}
      }).success(response => successCallback?.call(this, response)).error(response => errorCallback?.call(response));
    }

    public Reactivate(project: IProject, token, successCallback?: Function, errorCallback?: Function) {
      this.httpService.$http({
        method: 'PUT',
        url: `${this.configService.getServerBaseUrl()}/project/${project.id}/reactivate`,
        data: {token: token}
      }).success(response => successCallback?.call(this, response)).error(response => errorCallback?.call(this, response));
    }

    public SetReviewDateRange(project: IProject, begin: Date, end: Date) {
      const beginDateTime = moment.tz(moment(begin), moment.tz.utc);
      const endDateTime = moment.tz(moment(end), moment.tz.utc);

      return this.httpService.$http({
        method: 'PUT',
        url: `${this.configService.getServerBaseUrl()}/project/${project.id}/review/begin/${beginDateTime.format("YYYY-MM-DDThh:mm:ssZ")}/end/${endDateTime.format("YYYY-MM-DDThh:mm:ssZ")}`
      });
    }

    public GetTimeZoneIds() {
      let url = `${this.configService.getServerBaseUrl()}/project/timezones`;

      return this.httpService.$http({
        method: 'GET',
        url: url,
        data: ''
      });
    }

    public GetSftpPassword(project: IProject, successCallback?: Function, errorCallback?: Function, finallyCallback?: Function) {
      this.httpService.$http({
        method: 'GET',
        url: `${this.configService.getServerBaseUrl()}/project/${project.id}/sftp/password`
      })
        .then(response => {
          successCallback?.call(this, response.data);
        })
        .catch(error => {
          errorCallback?.call(this, error);
        })
        .finally(() => {
          finallyCallback?.call(this);
        });
    }

    public async UpdateProject(project: IProject) {
      return (this.AsResource(project) as any).$update();
    }
  }

  frontendApp.factory("ProjectService", ['$resource', '$rootScope', 'ConfigService', 'ResourceWrapperService', 'HttpService', function(resource, rootScope, configService, resourceWrapperService, httpService) {
    return new ProjectService(resource, rootScope, configService, resourceWrapperService, httpService);
  }]);
}
